export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/3785bb302560adf781a5462e1676b2d1.png";